export default __webpack_public_path__ + "static/media/deal-room-bg.8651c017.jpg";